import React from 'react';
import './Deposit.css';

const CryptoNetworkSelect = ({ onNetworkSelect }) => {
  const networks = [
    {
      id: 'ethereum',
      name: 'USDT Ethereum (ERC20)',
      currency: 'USDT',
      network_type: 'ERC20',
      logo: '/images/crypto-logos/ethereum.png',
      logoColor: '#627EEA'
    },
    {
      id: 'bsc',
      name: 'USDT BNB Smart Chain (BEP20)',
      currency: 'USDT',
      network_type: 'BEP20',
      logo: '/images/crypto-logos/bsc.png',
      logoColor: '#F0B90B'
    },
    {
      id: 'tron',
      name: 'USDT Tron (TRC20)',
      currency: 'USDT',
      network_type: 'TRC20',
      logo: '/images/crypto-logos/tron.png',
      logoColor: '#FF060A'
    },
    {
      id: 'solana',
      name: 'USDT Solana',
      currency: 'USDT',
      network_type: 'Solana',
      logo: '/images/crypto-logos/solana.png',
      logoColor: '#00FFA3'
    }
  ];

  return (
    <div className="crypto-network-select">
      <div className="section-header">
        <h2>Select Blockchain Network</h2>
      </div>

      <div className="networks-list">
        {networks.map((network) => (
          <div
            key={network.id}
            className="network-card"
            onClick={() => onNetworkSelect(network)}
          >
            <div className="network-logo">
              {network.logo ? (
                <img 
                  src={network.logo} 
                  alt={network.name}
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<div class="network-initial" style="background-color: ${network.logoColor || '#667eea'}">${network.currency.charAt(0)}</div>`;
                  }}
                />
              ) : (
                <div 
                  className="network-initial"
                  style={{ backgroundColor: network.logoColor || '#667eea' }}
                >
                  {network.currency.charAt(0)}
                </div>
              )}
            </div>
            <div className="network-info">
              <h3 className="network-name">{network.name}</h3>
              <span className="network-currency">{network.currency} - {network.network_type}</span>
            </div>
            <div className="network-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CryptoNetworkSelect;